const initStateGlobal = {
  appUrl: process.env.REACT_APP_RUNTIME_URL_SERVER,
  baseUrl: process.env.REACT_APP_RUNTIME_SERVER,
  isError: false,
  message: "Error",
  isLoading: false,
  isLoadingModal: false,
  isDrawerDesktopOpen: true,
  isDrawerMobileOpen: false,
  isModalFormOpen: false,
  isModalVerifyKtpOpen: false,
  isModalConfirmationOpen: false,
  isModalDescriptionOpen: false,
};

export const globalReducer = (state = initStateGlobal, action: any) => {
  if (action.type === "SET_ERROR") {
    return {
      ...state,
      isError: action.value.isError,
      message: action.value.message,
    };
  }
  if (action.type === "SET_LOADING") {
    return {
      ...state,
      isLoading: action.value,
    };
  }
  if (action.type === "SET_LOADING_MODAL") {
    return {
      ...state,
      isLoadingModal: action.value,
    };
  }
  if (action.type === "SET_DRAWER_DESKTOP") {
    return {
      ...state,
      isDrawerDesktopOpen: action.value,
    };
  }
  if (action.type === "SET_DRAWER_MOBILE") {
    return {
      ...state,
      isDrawerMobileOpen: action.value,
    };
  }
  if (action.type === "SET_MODAL_FORM") {
    return {
      ...state,
      isModalFormOpen: action.value,
    };
  }
  if (action.type === "SET_MODAL_VERIFY_KTP") {
    return {
      ...state,
      isModalVerifyKtpOpen: action.value,
    };
  }
  if (action.type === "SET_MODAL_CONFIRMATION") {
    return {
      ...state,
      isModalConfirmationOpen: action.value,
    };
  }
  if (action.type === "SET_MODAL_DESCRIPTION") {
    return {
      ...state,
      isModalDescriptionOpen: action.value,
    };
  }
  return state;
};
